export default "__VITE_ASSET__CZIkyXEj__"